import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { ScrollArea } from "../ui/scroll-area";
import { useCartStore } from "~/stores/use-cart-store";
import DiscountForm from "./order-discount-form";
import { useShallow } from "zustand/react/shallow";

export default function OrderDiscountDialog() {
  const {
    orderDiscountDialogOpen: discountDialogOpen,
    setOrderDiscountDialogOpen: setDiscountDialogOpen,
  } = useCartStore(
    useShallow((state) => ({
      orderDiscountDialogOpen: state.orderDiscountDialogOpen,
      setOrderDiscountDialogOpen: state.setOrderDiscountDialogOpen,
    }))
  );

  return (
    <Dialog open={discountDialogOpen} onOpenChange={setDiscountDialogOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Discount</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <ScrollArea className="max-h-[80vh] p-4">
          <DiscountForm onClose={() => setDiscountDialogOpen(false)} />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
}
